import { render, staticRenderFns } from "./CriterionRatingHeader.vue?vue&type=template&id=389f25e7&scoped=true&"
import script from "./CriterionRatingHeader.vue?vue&type=script&lang=js&"
export * from "./CriterionRatingHeader.vue?vue&type=script&lang=js&"
import style0 from "./CriterionRatingHeader.vue?vue&type=style&index=0&id=389f25e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389f25e7",
  null
  
)

export default component.exports